export type LabelCanvasFontOption = {
  id: string;
  label: string;
  family: string;
  category: 'sans' | 'serif' | 'display' | 'system';
};

export const LABEL_CANVAS_FONTS: LabelCanvasFontOption[] = [
  { id: 'system', label: 'System UI', family: 'system-ui, -apple-system, sans-serif', category: 'system' },
  { id: 'jakarta', label: 'Plus Jakarta Sans', family: '"Plus Jakarta Sans", sans-serif', category: 'sans' },
  { id: 'inter', label: 'Inter', family: 'Inter, sans-serif', category: 'sans' },
  { id: 'roboto', label: 'Roboto', family: 'Roboto, sans-serif', category: 'sans' },
  { id: 'poppins', label: 'Poppins', family: 'Poppins, sans-serif', category: 'sans' },
  { id: 'montserrat', label: 'Montserrat', family: 'Montserrat, sans-serif', category: 'sans' },
  { id: 'lato', label: 'Lato', family: 'Lato, sans-serif', category: 'sans' },
  { id: 'open-sans', label: 'Open Sans', family: '"Open Sans", sans-serif', category: 'sans' },
  { id: 'nunito', label: 'Nunito', family: 'Nunito, sans-serif', category: 'sans' },
  { id: 'source-sans', label: 'Source Sans 3', family: '"Source Sans 3", sans-serif', category: 'sans' },
  { id: 'merriweather', label: 'Merriweather', family: 'Merriweather, serif', category: 'serif' },
  { id: 'playfair', label: 'Playfair Display', family: '"Playfair Display", serif', category: 'display' },
  { id: 'georgia', label: 'Georgia', family: 'Georgia, "Times New Roman", serif', category: 'serif' },
  { id: 'courier', label: 'Courier (mono)', family: '"Courier New", Courier, monospace', category: 'system' },
];

export function fontFamilyForId(id: string | undefined): string {
  const found = LABEL_CANVAS_FONTS.find((f) => f.id === id);
  return found?.family ?? LABEL_CANVAS_FONTS[0].family;
}

export function fontIdForFamily(family: string | undefined): string {
  if (!family) return 'system';
  const exact = LABEL_CANVAS_FONTS.find((f) => f.family === family);
  if (exact) return exact.id;
  const partial = LABEL_CANVAS_FONTS.find((f) => family.includes(f.label));
  return partial?.id ?? 'system';
}
